import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appSelectOnFocus]',
  standalone: true,
})
export class SelectOnFocusDirective {
  private readonly el: HTMLInputElement | HTMLTextAreaElement;

  public constructor(elementRef: ElementRef<HTMLInputElement | HTMLTextAreaElement>) {
    this.el = elementRef.nativeElement;
  }

  @HostListener('focus')
  public onFocus(): void {
    if (this.el.readOnly || this.el.disabled) {
      return;
    }
    this.el.select()
  }
}
